module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"getTickets":"Tickets","soldOut":"Ausverkauft","free":"Kostenlos","from":"ab"},"en":{"getTickets":"Tickets","soldOut":"Sold Out","free":"Free","from":"from"}}')
  delete Component.options._Ctor
}
